import { useEffect } from 'react';
import { LoginBranding } from '../components/login/LoginBranding';
import { LoginFormPanel } from '../components/login/LoginFormPanel';

export function LoginPage() {
  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1024px)');

    const applyScrollLock = () => {
      const lock = mediaQuery.matches;
      document.documentElement.style.overflow = lock ? 'hidden' : '';
      document.body.style.overflow = lock ? 'hidden' : '';
    };

    applyScrollLock();
    mediaQuery.addEventListener('change', applyScrollLock);

    return () => {
      mediaQuery.removeEventListener('change', applyScrollLock);
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="min-h-screen lg:h-screen lg:overflow-hidden">
      <div className="grid min-h-screen lg:h-screen lg:grid-cols-2">
        <LoginBranding />
        <LoginFormPanel />
      </div>
    </div>
  );
}
